import { commonAxios, clientAxios } from '@/plugins/axios'

const baseUrl = '/v1/common'
export const login = async ({ accessToken }) =>
  commonAxios.post(
    `${baseUrl}/line-account/verify`,
    {
      line_access_token: accessToken,
    },
    {
      headers: {
        'x-provider': 'line',
      },
    }
  )

export const me = async () => commonAxios.post(`${baseUrl}/me`)
export const updateInfo = async (id, body) => clientAxios.put(`/v1/customer/${id}/update`, body)

export const deleteCard = ({ card_seq, customer_id, card_info }) =>
  clientAxios.delete(`/v1/customer/${customer_id}/card/${card_seq}/delete`, { data: { card_info } })

export const loginCustomer = (payload) => commonAxios.post(`${baseUrl}/login/customer/`, payload)

export const sendResetPassword = (email) => commonAxios.post(`${baseUrl}/reset-password/`, { email })

export const resetPasswordConfirm = (payload) => commonAxios.patch(`${baseUrl}/reset-password_confirm/`, payload)

export const verify = (payload) => commonAxios.post(`${baseUrl}/reset-password/verify`, payload)

export const customerSubscriptionError = () => clientAxios.get('/v1/customer/has-error-payment')

export const createCustomer = async (payload) => clientAxios.post('/v1/customer/new', payload)
